import React, { PureComponent } from 'react';
import style from './styles/style.module.css';


export default class ControlLink extends PureComponent {
    render() {
        return (
            <div className={ `${ style.controlLink } ${ this.props.className }` }
            style={ this.props.style }
            title={ this.props.title }
            onClick={ this.props.onClick }
            disabled={ this.props.disabled }>
                { this.props.children }
            </div>
        );
    }
}
ControlLink.defaultProps = {
    children: null,
    className: '',
    title: '',
};
